import { CmsService } from 'src/app/core/services/cms.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IndustryPurchasedInfo } from 'src/app/model/industry';
import { OperationResult } from '@tb/auth';
import { WorkFlowService } from './work-flow.service';
import { UrlMaker } from 'src/app/commons/url-maker';
import { AppSubscription } from 'src/app/model/subscription';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { InstanceVersionInfo } from 'src/app/model/instance';

@Injectable({ providedIn: 'root' })
export class SubscriptionService {
    public selectedIndustries: IndustryPurchasedInfo[] = [];
    public totalAmount: number = 0;
    public totalPackAmount: number = 0;
    storeApiUrl: string;

    constructor(private http: HttpClient, private workflow: WorkFlowService, private cmsService: CmsService) {
        this.storeApiUrl = environment.settings.storeApiUrl;
    }

    // --------------------------------------------------------------------------------
    // [HttpPost("/api/subscription/test/")] --> [HttpGet("api/getnewsubscriptionkey/{isdev}")]
    public async createTestSubscription(
        currentPurchasedIndustry: IndustryPurchasedInfo,
        selectedSubscriptionType: string,
        selectedDB: string,
        selectedInstanceKey: string,
        accountName: string,
        masterSubscriptionKey: string,
        isTester: string,
        isModifyingStatus: string,
        instanceVersionInfo: InstanceVersionInfo,
        selectedSnapshotID: string
    ): Promise<OperationResult> {
        selectedDB = selectedDB.length == 0 ? '' : selectedDB;

        let url = new UrlMaker().appendBaseUrl(this.storeApiUrl).appendSegment('subscription').appendSegment('test').toString();

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const jobj = {
            currentPurchasedIndustry: currentPurchasedIndustry,
            selectedSubscriptionType: selectedSubscriptionType,
            userRegionalSettins: this.workflow.getLanguageForCms(),
            userLanguage: this.workflow.getLanguageForCms(),
            selectedDB: selectedDB,
            selectedInstanceKey: selectedInstanceKey,
            masterSubscriptionKey: masterSubscriptionKey,
            accountName: accountName,
            isTester: isTester,
            isModifyingStatus: isModifyingStatus,
            instanceVersionInfo: instanceVersionInfo,
            selectedSnapshotID: selectedSnapshotID,
        };
        return this.http.post<OperationResult>(url, JSON.stringify(jobj), { headers: headers }).toPromise();
    }
    // --------------------------------------------------------------------------------
    //[HttpPost("/api/subscription/magoweb/test/")]
    public async createMagoWebTestSubscription(
        currentPurchasedIndustry: IndustryPurchasedInfo,
        currentLoggedAccountCompanyCode: string,
        currLoggedAccountCompanyName: string,
        accountName: string,
        isTester: string,
        isModifyingStatus: string,
        instanceVersionInfo: InstanceVersionInfo
    ): Promise<OperationResult> {
        let url = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('subscription')
            .appendSegment('magoweb')
            .appendSegment('test')
            .toString();

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const jobj = {
            currentPurchasedIndustry: currentPurchasedIndustry,
            userRegionalSettins: this.workflow.getLanguageForCms(),
            userLanguage: this.workflow.getLanguageForCms(),
            currentLoggedAccountCompanyCode: currentLoggedAccountCompanyCode,
            currLoggedAccountCompanyName: currLoggedAccountCompanyName,
            currAccountName: accountName,
            isTester: isTester,
            isModifyingStatus: isModifyingStatus,
            instanceVersionInfo: instanceVersionInfo,
        };
        return this.http.post<OperationResult>(url, JSON.stringify(jobj), { headers: headers }).toPromise();
    }

    //[HttpPost("/api/subscription/test/update")]---> [HttpPost("api/subscriptions/modify/{accountDoingAction}")] + altre
    // --------------------------------------------------------------------------------
    public async updateTestSubscription(
        currentPurchasedIndustry: IndustryPurchasedInfo,
        selectedSubscriptionType: string,
        selectedDB: string,
        selectedInstanceKey: string,
        appSubscription: AppSubscription,
        accountName: string,
        isTester: string,
        isModifyingStatus: string,
        instanceVersionInfo: InstanceVersionInfo
    ): Promise<OperationResult> {
        let urlSubscriptionSegment = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('subscription')
            .appendSegment('test')
            .appendSegment('update')
            .toString();
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        const jobj = {
            currentPurchasedIndustry: currentPurchasedIndustry,
            userRegionalSettins: this.workflow.getLanguageForCms(),
            userLanguage: this.workflow.getLanguageForCms(),
            selectedSubscriptionType: selectedSubscriptionType,
            selectedDB: selectedDB,
            selectedInstanceKey: selectedInstanceKey,
            masterSubscriptionKey: '',
            mpSubscription: appSubscription,
            accountName: accountName,
            isTester: isTester,
            isModifyingStatus: isModifyingStatus,
            instanceVersionInfo: instanceVersionInfo,
        };
        return this.http
            .post<OperationResult>(urlSubscriptionSegment, JSON.stringify(jobj), {
                headers: headers,
            })
            .toPromise();
    }
    //[HttpPost("api/subscription/createslave/")]
    public async createMultiCompanySub(
        masterSubscriptionKey: string,
        accountDoingAction: string,
        subdescription: string,
        isMagoWeb: boolean,
        gwamAccountEmail: string
    ): Promise<OperationResult> {
        let url = new UrlMaker().appendBaseUrl(this.storeApiUrl).appendSegment('subscription').appendSegment('createslave').toString();
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        const jobj = {
            masterSubscriptionKey: masterSubscriptionKey,
            accountDoingAction: accountDoingAction,
            subdescription: subdescription,
            isMagoWeb: isMagoWeb,
            gwamAccountEmail: gwamAccountEmail,
        };
        return this.http
            .post<OperationResult>(url.toString(), JSON.stringify(jobj), {
                headers: headers,
            })
            .toPromise();
    }
    // --------------------------------------------------------------------------------
    //[HttpPost("api/createorupdatesubscriptionnfs")]
    public async createorUpdateSubscriptionNFS(
        currentPurchasedIndustry: IndustryPurchasedInfo,
        accountEmail: string,
        currentAccountLogged: string,
        instanceVersionInfo: InstanceVersionInfo,
        isNfs?: string
    ): Promise<OperationResult> {
        let urlSubscriptionSegment = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('createorupdatesubscriptionnfs')
            .toString();
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const jobj = {
            purchasedIndustry: currentPurchasedIndustry,
            userRegionalSettins: this.workflow.getLanguageForCms(),
            userLanguage: this.workflow.getLanguageForCms(),
            gwamAccountEmail: accountEmail,
            currentAccountLogged: currentAccountLogged,
            isNfs: isNfs,
            instanceVersionInfo: instanceVersionInfo,
        };
        let s = this.toBinaryStr(JSON.stringify(jobj));
        return this.http
            .post<OperationResult>(urlSubscriptionSegment, JSON.stringify(btoa(s)), {
                headers: headers,
            })
            .toPromise();
    }

    public toBinaryStr(str) {
        const encoder = new TextEncoder();
        // 1: split the UTF-16 string into an array of bytes
        const charCodes = encoder.encode(str);
        var binary = '';
        var bytes = new Uint8Array(charCodes);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return binary;
    }
    // --------------------------------------------------------------------------------
    // [HttpGet("/api/subscription/{subscriptionKey}")]
    public async getSubscription(subscriptionKey: string): Promise<OperationResult> {
        let url = new UrlMaker().appendBaseUrl(this.storeApiUrl).appendSegment('subscription');

        if (subscriptionKey !== undefined) {
            url = url.appendSegment(subscriptionKey);
        }
        const urlString = url.toString();

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        return this.http.get<OperationResult>(urlString, { headers: headers }).toPromise();
    }

    // --------------------------------------------------------------------------------
    // [HttpGet("/api/subscription/{subscriptionKey}")]
    public async getSubscriptionDescription(subscriptionKey: string) {
        if (!subscriptionKey || subscriptionKey.length == 0) return '';

        let opRes: any = await this.getSubscription(subscriptionKey);
        if (opRes.Result) {
            let currentSubscription = opRes['Content'];
            return currentSubscription.Description;
        } else return '';
    }

    // --------------------------------------------------------------------------------
    public async getHeaderDescription(subscriptionDescri: string, isQuotation: boolean, language: string) {
        let cmsObj = await this.cmsService.getCmsObj(language, 'header');
        let youAreModifingaquotation = cmsObj.find((x) => x.ContentName == 'header.youAreModifingaquotation').ContentTranslation;
        let youAreModifinganIndustry = cmsObj.find((x) => x.ContentName == 'header.youAreModifinganIndustry').ContentTranslation;

        if (isQuotation) return youAreModifingaquotation.concat(' ', subscriptionDescri);
        else return youAreModifinganIndustry.concat(' ', subscriptionDescri);
    }

    // --------------------------------------------------------------------------------
    //[HttpPost("api/subscriptiongeneralinfo/modify")]
    saveSubscription(body: AppSubscription): Observable<OperationResult> {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const url = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('subscriptiongeneralinfo')
            .appendSegment('modify')
            .appendSegment(body.SubscriptionKey)
            .toString();

        return this.http
            .post<OperationResult>(url, body, { headers: headers })
            .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error in saveSubscription')));
    }

    // --------------------------------------------------------------------------------
    //[HttpGet("/api/subw4impexp/{accountName}")]
    getSubscriptions4ImpExp(accountName: string, subscriptionKey?: string): Observable<OperationResult> {
        if (accountName === '') {
            return throwError('The account name for getSubscriptions is missing!');
        }

        let url = new UrlMaker().appendBaseUrl(this.storeApiUrl).appendSegment('subw4impexp').appendSegment(accountName);

        if (subscriptionKey !== undefined && subscriptionKey !== null && subscriptionKey !== '') {
            url = url.appendSegment(subscriptionKey);
        }
        const urlString = url.toString();

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        return this.http.get<OperationResult>(urlString, { headers: headers }).pipe(
            catchError((error: HttpErrorResponse) => {
                let errorDetail = error.message;

                if (error.status === 401) {
                    return throwError('Unauthorized: ' + errorDetail);
                }
                if (error.status === 403) {
                    return throwError('Forbidden resource: ' + errorDetail);
                }

                return throwError(errorDetail || 'server error (getSubscriptions)');
            })
        );
    }

    // --------------------------------------------------------------------------------
    //[HttpGet("/api/subscriptions/{accountName}/{subscriptionKey?}")]
    getSubscriptions(accountName: string, subscriptionKey?: string): Observable<OperationResult> {
        if (accountName === '') {
            return throwError('The account name for getSubscriptions is missing!');
        }

        let url = new UrlMaker().appendBaseUrl(this.storeApiUrl).appendSegment('subscriptions').appendSegment(accountName);

        if (subscriptionKey !== undefined && subscriptionKey !== null && subscriptionKey !== '') {
            url = url.appendSegment(subscriptionKey);
        }
        const urlString = url.toString();

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        return this.http.get<OperationResult>(urlString, { headers: headers }).pipe(
            catchError((error: HttpErrorResponse) => {
                let errorDetail = error.message;

                if (error.status === 401) {
                    return throwError('Unauthorized: ' + errorDetail);
                }
                if (error.status === 403) {
                    return throwError('Forbidden resource: ' + errorDetail);
                }

                return throwError(errorDetail || 'server error (getSubscriptions)');
            })
        );
    }

    // --------------------------------------------------------------------------------
    //[HttpGet("/api/subscriptions/{accountName}/{subscriptionKey?}")]
    async getSubscriptionsToPromise(accountName: string, subscriptionKey?: string): Promise<AppSubscription> {
        let url = new UrlMaker().appendBaseUrl(this.storeApiUrl).appendSegment('subscriptions').appendSegment(accountName);

        if (subscriptionKey !== undefined && subscriptionKey !== '') {
            url = url.appendSegment(subscriptionKey);
        }

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        return this.http
            .get<AppSubscription>(url.toString(), { headers: headers })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let errorDetail = error.message;

                    if (error.status === 401) {
                        return throwError('Unauthorized: ' + errorDetail);
                    }
                    if (error.status === 403) {
                        return throwError('Forbidden resource: ' + errorDetail);
                    }

                    return throwError(errorDetail || 'server error (getSubscriptionsToPromise)');
                })
            )
            .toPromise();
    }

    // --------------------------------------------------------------------------------
    //[HttpGet("/api/subscriptionsCount/{accountName}")]
    async getSubscriptionsCountToPromise(accountName: string): Promise<OperationResult> {
        let url = new UrlMaker().appendBaseUrl(this.storeApiUrl).appendSegment('subscriptionsCount').appendSegment(accountName);

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        return this.http
            .get<OperationResult>(url.toString(), { headers: headers })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let errorDetail = error.message;

                    if (error.status === 401) {
                        return throwError('Unauthorized: ' + errorDetail);
                    }
                    if (error.status === 403) {
                        return throwError('Forbidden resource: ' + errorDetail);
                    }

                    return throwError(errorDetail || 'server error (getSubscriptionsCountToPromise)');
                })
            )
            .toPromise();
    }

    // --------------------------------------------------------------------------------
    //[HttpGet("api/subsintersect_bis/{accountNameLogin}/{accountNameCheck}")]
    getSubscriptionsIntersect(accountNameForMySubs: string, accountNameToCheck: string): Observable<OperationResult> {
        if (accountNameForMySubs === '') {
            return throwError('The accountNameForMySubs for getSubscriptionsIntersect is missing!');
        }
        if (accountNameToCheck === '') {
            console.log('The accountNameToCheck for getSubscriptionsIntersect is missing!');
            return;
        }

        let url = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('subsintersect_bis')
            .appendSegment(accountNameForMySubs)
            .appendSegment(accountNameToCheck)
            .toString();

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        return this.http.get<OperationResult>(url, { headers: headers }).pipe(
            catchError((error: HttpErrorResponse) => {
                let errorDetail: string;
                try {
                    // errorDetail = error.message;
                    errorDetail = error.message;
                } catch (e) {
                    errorDetail = error.error;
                }

                if (error.status === 401) {
                    return throwError('Unauthorized: ' + errorDetail);
                }
                if (error.status === 403) {
                    return throwError('Forbidden resource: ' + errorDetail);
                }

                return throwError(error.error || 'server error (getSubscriptions)');
            })
        );
    }

    // --------------------------------------------------------------------------------
    //[HttpGet("/api/subscriptionswinstancekeyST/{accountName}/{subscriptionKey?}")]
    getSubscriptionsWithInstanceKeyToPromise(accountName: string, subscriptionKey: string = null): Promise<OperationResult> {
        let url = new UrlMaker().appendBaseUrl(this.storeApiUrl).appendSegment('subscriptionswinstancekeyST').appendSegment(accountName);
        // let url = new UrlMaker().appendBaseUrl(this.gwamApiUrl).appendSegment('subscriptionswinstancekey3').appendSegment(accountName);

        if (subscriptionKey !== undefined && subscriptionKey !== null && subscriptionKey !== '') {
            url = url.appendSegment(subscriptionKey);
        }

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        return this.http
            .get<OperationResult>(url.toString(), { headers: headers })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let errorDetail = error.message;

                    if (error.status === 401) {
                        return throwError('Unauthorized: ' + errorDetail);
                    }
                    if (error.status === 403) {
                        return throwError('Forbidden resource: ' + errorDetail);
                    }

                    return throwError(errorDetail || 'server error (getSubscriptionsWithInstanceKey)');
                })
            )
            .toPromise();
    }

    // --------------------------------------------------------------------------------
    // [HttpGet("/api/subscriptions/NFS/{accountName}/{partnerCode}")]
    getSubscriptionsNFS(accountName: string, partnerCode: string): Promise<OperationResult> {
        let url = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('subscriptions')
            .appendSegment('NFS')
            .appendSegment(accountName)
            .appendSegment(partnerCode);

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        return this.http
            .get<OperationResult>(url.toString(), { headers: headers })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let errorDetail = error.message;

                    if (error.status === 401) {
                        return throwError('Unauthorized: ' + errorDetail);
                    }
                    if (error.status === 403) {
                        return throwError('Forbidden resource: ' + errorDetail);
                    }

                    return throwError(errorDetail || 'server error (getSubscriptionsWithInstanceKey)');
                })
            )
            .toPromise();
    }

    // --------------------------------------------------------------------------------
    //[HttpGet("/api/slavesubscriptions/{mastersubscriptionKey}")]
    getSlaveSubscription(mastersubscriptionKey: string): Observable<OperationResult> {
        if (mastersubscriptionKey === undefined || mastersubscriptionKey == '') return throwError('mastersubscriptionKey is missing!');

        let url = new UrlMaker().appendBaseUrl(this.storeApiUrl).appendSegment('slavesubscriptions').appendSegment(mastersubscriptionKey);

        const urlString = url.toString();

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        return this.http.get<OperationResult>(urlString, { headers: headers }).pipe(
            catchError((error: HttpErrorResponse) => {
                let errorDetail = error.message;

                if (error.status === 401) {
                    return throwError('Unauthorized: ' + errorDetail);
                }
                if (error.status === 403) {
                    return throwError('Forbidden resource: ' + errorDetail);
                }

                return throwError(errorDetail || 'server error (getSlaveSubscription)');
            })
        );
    }

    // --------------------------------------------------------------------------------
    //[HttpGet("/api/version/{subscriptionKey}")]
    getVersionBySubscriptionKey(subscriptionKey: string): Observable<OperationResult> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        const url = new UrlMaker().appendBaseUrl(this.storeApiUrl).appendSegment('version').appendSegment(subscriptionKey).toString();

        // hint: map the Content in a SubscriptionVersion object (look in in src\app\model\subscription.ts)
        // so create the object with this code:
        // let subVersion = SubscriptionVersion.create(getVersionResult.Content);

        return this.http
            .get<OperationResult>(url, { headers: headers })
            .pipe(catchError((error: any) => throwError(error || 'server error (getVersionBySubscriptionKey)')));
    }
    // --------------------------------------------------------------------------------
    //[HttpPost("api/sendmagowebemail/{subcriptionKey}")]
    sendMagoWebEmail(subscriptionKey: string): Promise<OperationResult> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        const url = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('sendmagowebemail')
            .appendSegment(subscriptionKey)
            .toString();

        // hint: map the Content in a SubscriptionVersion object (look in in src\app\model\subscription.ts)
        // so create the object with this code:
        // let subVersion = SubscriptionVersion.create(getVersionResult.Content);

        return this.http
            .post<OperationResult>(url, { headers: headers })
            .pipe(catchError((error: any) => throwError(error || 'server error (getVersionBySubscriptionKey)')))
            .toPromise();
    }
}
